export enum PropertyOwnership {
    ownResidentialProperty = 'ownResidentialProperty',
    ownResidentialPropertyAtDifferentAddress = 'ownResidentialPropertyAtDifferentAddress',
    ownNoResidentialProperty = 'ownNoResidentialProperty',
    residentialPropertyownedbySpouse = 'residentialPropertyownedbySpouse'
}
